import React, { FC } from 'react';
import styles from './CustomBox.module.scss';

interface CustomBoxProps {
  label: string;
  description: string | null | number;
  icon: React.ReactNode;
  iconColor: string;
  backgroundColor: string;
  iconBackgroundColor?: string;
  svgStyle?: React.CSSProperties;
  footer?: React.ReactNode;
  variant?: boolean;
}

const CustomBox: FC<CustomBoxProps> = ({
  label,
  icon,
  iconColor,
  description,
  backgroundColor,
  iconBackgroundColor,
  svgStyle,
  footer,
  variant,
}) => {
  const iconStyles = {
    color: iconColor,
    backgroundColor: iconBackgroundColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...svgStyle,
  };

  const boxStyles = {
    backgroundColor,
  };

  return (
    <div className={styles.customBox} style={boxStyles}>
      <div className={styles.mainContainer}>
        <div className={styles.icon} style={iconStyles}>
          <div>{icon}</div>
        </div>
        <div className={styles.content}>
          <div className={!variant ? styles.label : styles.labelVariant}>
            {label}
          </div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};

export default CustomBox;
